import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link, useNavigate } from 'react-router-dom'
import HeadTitle from '../../components/HeadTitle'
import { withContext } from '../../AuthContext'
import LogIn from '../../components/LogIn'
import ForgotPassword from '../../components/ForgotPassword'
import RequireNewPassword from '../../components/RequireNewPassword'
import ResetPassword from '../../components/ResetPassword'
import ConfirmLogIn from '../../components/ConfirmLogIn'
import AuthorizeLogin from '../../components/AuthorizeLogin'
import { TextLink } from '@otcmarketsgroup/otcm-ui'
import styles from './AuthPage.module.scss'

const renderAuthComponent = (authState) => {
    switch (authState) {
        case 'LOG_IN':
            return <LogIn />
        case 'NEW_PASSWORD_REQUIRED':
            return <RequireNewPassword />
        case 'SMS_MFA':
            return <ConfirmLogIn />
        case 'FORGOT_PASSWORD':
            return <ForgotPassword />
        case 'RESET_PASSWORD':
            return <ResetPassword />
        case 'AUTHORIZE_LOGIN':
            return <AuthorizeLogin />
        default:
            return null
    }
}

const AuthPage = ({ context }) => {
    const { isAuth, authState } = context
    const navigate = useNavigate()

    useEffect(() => {
        if (isAuth) {
            navigate('/dashboard')
        }
    }, [isAuth, navigate])

    return (
        <div className={styles.container}>
            <HeadTitle title='OTC Markets Compliance UI' />
            <Link to='/' className={styles.logo}>
                <img src='/logos/otc-black.svg' alt='logo' />
            </Link>

            {renderAuthComponent(authState)}

            <footer className={styles.footer}>
                <TextLink text='Terms' href='https://www.otcmarkets.com/terms-of-service' target='blank' />
                <TextLink text='Privacy' href='https://www.otcmarkets.com/privacy-statement' target='blank' />
                <Link to='/contact'>
                    <TextLink text='Contact' target='blank' />
                </Link>
            </footer>
        </div>
    )
}

AuthPage.propTypes = {
    context: PropTypes.shape({
        authState: PropTypes.string,
        isAuth: PropTypes.bool
    }).isRequired
}

export default withContext(AuthPage)